// API related actions
export const FETCHING_VEHICLES_EFFICIENCY = '@@toyota/FETCHING_VEHICLES_EFFICIENCY';
export const FETCHED_VEHICLES_EFFICIENCY = '@@toyota/FETCHED_VEHICLES_EFFICIENCY';
export const FETCHED_VEHICLES_EFFICIENCY_FAILED = '@@toyota/FETCHED_VEHICLES_EFFICIENCY_FAILED';
export const DOWNLOADING_VEHICLES_EFFICIENCY = '@@toyota/DOWNLOADING_VEHICLES_EFFICIENCY';
export const DOWNLOADED_VEHICLES_EFFICIENCY = '@@toyota/DOWNLOADED_VEHICLES_EFFICIENCY';
export const DOWNLOADED_VEHICLES_EFFICIENCY_FAILED = '@@toyota/DOWNLOADED_VEHICLES_EFFICIENCY_FAILED';

// complementary actions
export const CLEAR_VEHICLES_EFFICIENCY = '@@toyota/CLEAR_VEHICLES_EFFICIENCY';
export const CLEAR_CHASSIS_INFO = '@@toyota/CLEAR_CHASSIS_INFO';
export const CLEAR_URL_VEHICLES_EFFICIENCY = '@@toyota/CLEAR_URL_VEHICLES_EFFICIENCY';
